<template>
    <div class="attachments d-flex w-100">
        <div @click="showAttachmentsModal(i)" v-for="(attachment, i) in attachments" :key="i">
            <div v-if="attachment.extension === 'pdf' || attachment.type === 'pdf'" class="pdf">
                <pdf :src="attachment.url"></pdf>
            </div>
            <div v-else class="attachment" :style="`background-image: url(${attachment.url})`"></div>
        </div>

        <FilesPreviewModal ref="attachments-modal" :attachments="attachments" />
    </div>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar'
import FilesPreviewModal from '@/components/Utils/FilesPreviewModal'
import pdf from 'vue-pdf'

export default {
    components: {
        VueCustomScrollbar,
        FilesPreviewModal,
        pdf,
    },
    props: {
        attachments: Array,
    },
    methods: {
        showAttachmentsModal(index) {
            this.$refs['attachments-modal'].show(index)
        },
    },
}
</script>

<style lang="scss" scoped>
.attachments {
    flex-wrap: wrap;
    .attachment {
        margin: 8px;
        height: 169px;
        width: 120px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        cursor: pointer;
        transition: transform 0.3s;
        border-radius: 2px;
        &:hover {
            transition: transform 0.3s;
            transform: scale(1.05);
        }
    }
    .pdf {
        margin: 8px;
        height: 169px;
        width: 120px;
        cursor: pointer;
        transition: transform 0.3s;
        &:hover {
            transition: transform 0.3s;
            transform: scale(1.05);
        }
    }
}
</style>
